import React from "react";
import {
  CalendarDaysInMonth,
  CalendarDaysInMonthProps,
} from "./CalendarDaysInMonth";
import { CalendarWeek } from "./CalendarWeek";

export interface CalendarProps<T> extends CalendarDaysInMonthProps<T> {
  className?: string;
  style?: React.CSSProperties;
}

export const Calendar = <T,>({
  className,
  style,
  renderCell,
  ...props
}: CalendarProps<T>) => (
  <div className={className} style={style}>
    <CalendarWeek />
    <CalendarDaysInMonth {...props} renderCell={renderCell} />
  </div>
);
